module.exports = __webpack_public_path__ + "img/img7.68b41b22.png";